import React, { useCallback, useState } from 'react'
import { CCard, CCardBody, CCol, CRow } from '@coreui/react-pro'
import { Navigate, useLocation, useParams } from 'react-router-dom'
import TimelineSetting from './TimelineSetting'
import Table from './Table'
import { PULSE_TYPES } from './pulseTypes'
import './Timeline.css'

const Timeline = () => {
  const { state } = useLocation()
  const initialTab = PULSE_TYPES.some((t) => t.key === state?.tab) ? state.tab : PULSE_TYPES[0].key
  const [activeTab, setActiveTab] = useState(initialTab)
  const [totals, setTotals] = useState({ fantasy: null, batting: null, bowling: null })
  const [settings, setSettings] = useState(null)
  // Bumped after the thresholds are saved so every list refetches against the new values.
  const [refreshKey, setRefreshKey] = useState(0)

  const setTotal = useCallback(
    (key, total) =>
      setTotals((current) => (current[key] === total ? current : { ...current, [key]: total })),
    [],
  )

  return (
    <>
      <div className="ge-page-header">
        <h1 className="ge-page-title">Pulse</h1>
        <p className="ge-page-subtitle">
          Standout innings from this game&apos;s matches, and the thresholds that decide what makes
          the feed.
        </p>
      </div>

      <CRow className="g-3">
        <CCol xs={12}>
          <TimelineSetting
            onLoaded={setSettings}
            onSaved={(saved) => {
              setSettings(saved)
              setRefreshKey((k) => k + 1)
            }}
          />
        </CCol>

        <CCol xs={12}>
          <div className="ge-tabs mb-0" role="tablist">
            {PULSE_TYPES.map((tab) => (
              <button
                key={tab.key}
                type="button"
                role="tab"
                aria-selected={activeTab === tab.key}
                className={`ge-tab${activeTab === tab.key ? ' active' : ''}`}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.label}
                {totals[tab.key] !== null && (
                  <span className="ge-tab-count">{totals[tab.key]}</span>
                )}
              </button>
            ))}
          </div>
        </CCol>

        <CCol xs={12}>
          <CCard className="pl-panel">
            <CCardBody>
              {/* All three lists stay mounted so each tab's count shows before it is opened. */}
              {PULSE_TYPES.map((type) => (
                <div key={type.key} className={activeTab === type.key ? undefined : 'd-none'}>
                  <Table
                    type={type}
                    threshold={settings?.[type.settingKey]}
                    refreshKey={refreshKey}
                    onTotalChange={setTotal}
                  />
                </div>
              ))}
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </>
  )
}

// /pulse-listing/:type used to be three separate pages; land old links on the matching tab.
export const PulseListingRedirect = () => {
  const { type } = useParams()
  return <Navigate to="/pulse" replace state={{ tab: type }} />
}

export default Timeline
